import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from "react-toastify";
import StepsGuideModal from './StepsGuideModal';


const CreateCatalogBtn = () => {
  const navigate = useNavigate();
  const user = localStorage.getItem("user");
  const [showStepsModal, setShowStepsModal] = useState(false);

  const handleCreateCatalog = () => {
    if (!user) {
      setShowStepsModal(true);
    } else {
      navigate("/createCatalog");
    }
  };

  const handleProceedToCatalog = () => {
    if (user) {
      navigate("/createCatalog");
    } else {
      navigate("/login");
    }
  };

  return (
    <React.Fragment>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div className='createCatelogDiv'>
        <button onClick={handleCreateCatalog} className='catalogue-vertical'>
          Create Catalogue
        </button>
      </div>

      <StepsGuideModal
        show={showStepsModal}
        onHide={() => setShowStepsModal(false)}
        onProceed={handleProceedToCatalog}
      />
    </React.Fragment>
  )
}

export default CreateCatalogBtn
